import { Column, TableCollectionTemplate } from '../collection/base-templates/table/table.model';
import { Action } from '../collection/collection.model';
import { getEditAction, getExportAction, getRemoveAction, menuAction } from '../collection/collection.data';

export { PublicDataSource } from '../../../../../../api/src/data-source/data-source.entity';
export { DataSourceConnectorType, DataSourceContext, ItemFormat } from '../../../../../../api/src/data-source/models';

export const getDataSourcesListTableColumns = (): Column[] => [
	{
		id: 'name',
		name: $localize `:Table Name Column Label@@tableColumnNameLabel:Name`,
		path: 'name',
		type: 'field',
		width: 250,
		linked: {
			bubble: true
		}
	},
	{
		id: 'slug',
		name: $localize `:Table Slug Column Label@@tableColumnSlugLabel:Slug`,
		path: 'slug',
		type: 'field',
		width: 250
	},
	{
		id: 'connectorType',
		name: $localize `:Table Context Connector Type Label@@tableColumnConnectorTypeLabel:Connector Type`,
		path: 'connectorType',
		type: 'field',
		width: 200
	},
	{
		id: 'target',
		name: $localize `:Table Slug Target Label@@tableColumnTargetLabel:Target`,
		path: 'config.target',
		type: 'field',
		width: 200,
		disableSort: true
	},
	{
		id: 'context',
		name: $localize `:Table Context Target Label@@tableColumnContextLabel:Context`,
		path: 'config.context',
		type: 'field',
		width: 250,
		disableSort: true
	}
];

const getContextMenuAction = (): Action => ({
	...menuAction,
	actionSettings: [
		{ ...getEditAction(), methodName: undefined }, 
		{ ...getExportAction(), resultMethodName: undefined }, 
		getRemoveAction()
	]
});

export const getDataSourcesListTableActions = (): Action[] => [getContextMenuAction()];

export const getDataSourcesListTableCollectionTemplate = (): TableCollectionTemplate => ({
	id: 'data-sources-table',
	slug: 'table',
	name: 'Table',
	settings: {
		filterSidebar: false,
		defaultLimit: 10,
		limitOptions: [5, 10, 25],
		columns: getDataSourcesListTableColumns(),
		activeColumns: getDataSourcesListTableColumns(),
		actions: getDataSourcesListTableActions()
	}
});
